import type { ReactNode } from "react";
import { useReveal } from "../hooks/useReveal";

/** Fade-up reveal on scroll (same animation as the sample homepage). */
const Reveal = ({ children, className = "" }: { children: ReactNode; className?: string }) => {
  const ref = useReveal();
  return (
    <div ref={ref} className={`animate-reveal ${className}`}>
      {children}
    </div>
  );
};

export default Reveal;
